import React, { useEffect, useState } from 'react';
import { themeCreator } from './base';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';

export const ThemeContext = React.createContext();

const ThemeProviderWrapper = (props) => {
  const normalizeThemeName = (themeName) => {
    if (themeName === 'dark' || themeName === 'NebulaFighterTheme') {
      return 'NebulaFighterTheme';
    }

    return 'ClarkTheme';
  };

  const curThemeName = normalizeThemeName(localStorage.getItem('appTheme') || 'ClarkTheme');
  const [themeName, _setThemeName] = useState(curThemeName);
  const theme = themeCreator(themeName);

  const setThemeName = (themeName) => {
    const normalizedThemeName = normalizeThemeName(themeName);
    localStorage.setItem('appTheme', normalizedThemeName);
    _setThemeName(normalizedThemeName);
  };

  useEffect(() => {
    document.documentElement.dataset.theme = themeName === 'NebulaFighterTheme' ? 'dark' : 'light';
  }, [themeName]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeContext.Provider value={{ themeName, setThemeName }}>
        <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
      </ThemeContext.Provider>
    </StyledEngineProvider>
  );
};

export default ThemeProviderWrapper;
